import { SupplierModelType } from '@teinor/erp/types/company/supplier'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import SingleFormLayout from '../../../../../../../../baseComponents/Layout/SingleFormLayout'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

interface CreditorTradeAgreementsProps extends ComponentWithPermissions {
    basicData: SupplierModelType | null
    getData: () => Promise<void>
}

const CreditorTradeAgreements: React.FC<CreditorTradeAgreementsProps> = ({ basicData, userPermissions, getData }) => {
    const { t } = useTwinTranslation()

    const fields: FormRender<SupplierModelType> = [
        {
            cols: 2,
            title: t('generalInformation', 'Información general'),
            elements: [

                {
                    name: 'special_discount',
                    label: t('specialDiscount', 'Descuento especial'),
                    component: 'InputNumberWithLabelMarginStateFull',
                },
                {
                    name: 'financing',
                    label: t('financing', 'Financiación'),
                    component: 'InputNumberWithLabelMarginStateFull',
                },
                {
                    name: 'unit_discount',
                    label: t('unitDiscount', 'Descuento unitario'),
                    component: 'InputNumberWithLabelMarginStateFull',
                },
                {
                    name: 'unit_margin',
                    label: t('unitMargin', 'Margen unitario'),
                    component: 'InputNumberWithLabelMarginStateFull',
                },
                {
                    name: 'weight_discount',
                    label: t('weightDiscount', 'Descuento por peso'),
                    component: 'InputNumberWithLabelMarginStateFull',
                },
                {
                    name: 'weight_margin',
                    label: t('weightMargin', 'Margen por peso'),
                    component: 'InputNumberWithLabelMarginStateFull',
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                }
            ]
        },

    ]
    const parsedFields = valueOrDefaultValue(fields, userPermissions, basicData)

    return (
        <SingleFormLayout action='/api/app/supplier/updateSupplier' onSubmit={getData} imagepath={['supplier', String(basicData?.id)]} userPermissions={userPermissions} sections={parsedFields} />
    )
}


export default CreditorTradeAgreements